import { Action, createAction, handleActions } from "redux-actions";
import { GetNovedadResponse } from "~api/types";
import { Services } from "../types";

interface CurrentNovedadPayload {
  currentNovedad: GetNovedadResponse | null;
}

interface DetalleNovedadState {
  currentNovedad: GetNovedadResponse | null;
  isLoading: boolean;
  failed: boolean;
}

const setInitialState = createAction("SET_DETALLE_NOVEDADES_INITIAL_STATE");

const setCurrentNovedad = createAction(
  "SET_CURRENT_USUARIO",
  (currentNovedad: GetNovedadResponse | null): CurrentNovedadPayload => ({
    currentNovedad,
  })
);

const getNovedadInited = createAction("OBTENER_NOVEDAD_INITED");

const getNovedadCompleted = createAction(
  "OBTENER_NOVEDAD_COMPLETED",
  (currentNovedad: GetNovedadResponse): CurrentNovedadPayload => ({
    currentNovedad,
  })
);

const getNovedadFailed = createAction(
  "OBTENER_NOVEDAD_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getNovedad = (id: string) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getNovedadInited());

      const response = await services.api.novedades().getNovedad(id);

      dispatch(getNovedadCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getNovedadFailed(error));
    }
  };
};

const detalleNovedadInitialState: DetalleNovedadState = {
  currentNovedad: null,
  isLoading: false,
  failed: false,
};

const detalleNovedadReducer = handleActions<DetalleNovedadState, any>(
  {
    [setInitialState.toString()]: (): DetalleNovedadState => {
      return {
        ...detalleNovedadInitialState,
      };
    },
    [setCurrentNovedad.toString()]: (
      state: DetalleNovedadState,
      action: Action<CurrentNovedadPayload>
    ): DetalleNovedadState => {
      return {
        ...state,
        currentNovedad: action.payload.currentNovedad,
      };
    },
    [getNovedadInited.toString()]: (
      state: DetalleNovedadState
    ): DetalleNovedadState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getNovedadCompleted.toString()]: (
      state: DetalleNovedadState,
      action: Action<CurrentNovedadPayload>
    ): DetalleNovedadState => {
      return {
        ...state,
        currentNovedad: action.payload.currentNovedad,
        isLoading: false,
        failed: false,
      };
    },
    [getNovedadFailed.toString()]: (
      state: DetalleNovedadState
    ): DetalleNovedadState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
  },
  detalleNovedadInitialState
);

export { detalleNovedadReducer };
export { getNovedad, setInitialState, setCurrentNovedad };
